import React, { memo, useCallback, useMemo } from 'react'

import { Icon, Button, PersonSingle } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import DesignerContent from 'Pods/SearchPage/Shared/DesignerContent/DesignerContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { clearDesigners } from 'Pods/SearchPage/Store/actions/designers'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

const prefixIcon = <Icon notSpaced svgComponent={PersonSingle} color="dark" size="small" />

function Designers() {
  const translate = useTranslate()

  const designers = useSearchPageStore(state => state.designers ?? EMPTY_ARRAY)

  const hasSelectedAnyFilter = designers.length > 0

  const handleReset = useCallback(() => {
    clearDesigners()
  }, [])

  const content = useMemo(() => (
    <>
      <DesignerContent />
      <Button
        type="ghost"
        size="tiny"
        customClass="filter-wrapper__reset-button"
        onClick={handleReset}
        disabled={!hasSelectedAnyFilter}
      >
        {translate('search_page.filters.more_filters.reset')}
      </Button>
    </>
  ), [handleReset, hasSelectedAnyFilter, translate])

  return (
    <FiltersWrapper
      placeholder={translate('search_page.filters.designers.title')}
      prefixIcon={prefixIcon}
      content={content}
      hasSelectedAnyFilters={hasSelectedAnyFilter}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(Designers)
